/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { isEmpty, get } from 'lodash';
import Delete from '@material-ui/icons/Delete';
import { Loyalty } from '@material-ui/icons';
import ColumnsList from '../../Shared/ColumnsList';
import { removeSubscription } from '../Shared/helpers';
import { decode } from '../Shared/encode';
import ErrorModal from '../../Shared/ErrorModal';
import { defaultErrorMessage } from '../../../constants';

class SoothePassInCart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      showErrorModal: false,
    };
    this.deleteSub = this.deleteSub.bind(this);
    this.errorModal = this.errorModal.bind(this);
    this.displaySubscriptionTag = this.displaySubscriptionTag.bind(this);
  }

  deleteSub() {
    const cartId = get(this.props, 'booking.cart.id', '');
    if (cartId) {
      removeSubscription(cartId, (response) => {
        this.props.assignToCart({ cart: decode(response.data.cart) });
      }, (err) => {
        this.setState({ showErrorModal: true, error: get(err, 'errors.0.message', defaultErrorMessage) });
      });
    }
  }

  errorModal() {
    return (
      <ErrorModal
        isOpen={this.state.showErrorModal}
        close={() => { this.setState({ showErrorModal: false, error: null }); }}
      >
        <p>{this.state.error}</p>
      </ErrorModal>
    );
  }

  displaySubscriptionTag() {
    const alreadyAppliedToCart = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_applied_to_cart', false);
    const isSoothePassAvailable = get(this.props, 'booking.cart.info_fields.soothe_pass.available', false);
    const { has_discount, service_text } = get(this.props, 'client.soothe_pass.discount', {});
    
    if (alreadyAppliedToCart && isSoothePassAvailable) {
      if(has_discount){
      return (
        <div className="subscription-tag">
          <div className="subscription-tag-content">
            <Loyalty className="loyalty-icon" />
            <span className="subscription-tag-text">
              Limited time offer: {service_text}
            </span>
          </div>
        </div>
      );
    }
    }
    return null;
  }

  render() {
    const soothePassObj = get(this.props, 'booking.cart.info_fields.soothe_pass', null);
    const alreadyAppliedToCart = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_applied_to_cart', false);

    if (alreadyAppliedToCart && !isEmpty(soothePassObj)) {
      return (
        <>
          <div className="row">
            <div className="col-xs-10 col-sm-11">
              <ColumnsList
                headerText={<div className="medium-font">SoothePass™</div>}
                itemsList={[{
                  text: (<div>
                    {get(soothePassObj, 'subscription_tier_name', '')}
                    ,
                    {' '}
                    {get(soothePassObj, 'subscription_points', 0)}
                    {' '}
                    points
                  </div>),
                }, {
                  text: (<div>{get(soothePassObj, 'subscription_tier_price', '')}</div>),
                }]}
              />
              {this.displaySubscriptionTag()}
            </div>
            <div className="col-xs-2 col-sm-1">
              <button
                type="button"
                className="btn edit-icon"
                onClick={() => this.deleteSub()}
              >
                <Delete />
              </button>
            </div>
          </div>
          {this.errorModal()}
        </>
      );
    }
    return null;
  }
}
const mapStateToProps = (state) => ({
  booking: state.booking,
  addresses: state.addresses,
  client: state.client,
});

SoothePassInCart.propTypes = {
  booking: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
};

export default withLocalize(connect(mapStateToProps)(SoothePassInCart));
